module.exports = __webpack_public_path__ + "img/1F63A.a987673d.svg";